import { useContext } from 'react';
import { PortalContext } from '../context/portal-context';
import { Discount } from '@esportal/portal-service';

export const discountHelper = () => {
	const { portalService } = useContext(PortalContext);

	const discounts = portalService?.getPersonBenefits().getValue()?.benefits.discounts || [];
	const discountNames = discounts.map((discount) => discount.name);
	const discountIds = discounts.map((discount) => discount.id);

	const getDiscountByName = (name: string): Discount | undefined => {
		return discounts.find((discount) => discount.name === name);
	};

	const getDiscountById = (id: string): Discount | undefined => {
		return discounts.find((discount) => discount.id === id);
	};

	const hasDiscount = (name: string): boolean => {
		return discountNames.includes(name) || discountIds.includes(name);
	};

	const getDiscountOrFallback = (primaryName: string, fallbackName: string): Discount | undefined => {
		return (
			getDiscountByName(primaryName) ||
			getDiscountById(primaryName) ||
			getDiscountByName(fallbackName) ||
			getDiscountById(fallbackName) ||
			discounts[0]
		);
	};

	const formatNumberWithThousands = (value: string | number): string => {
		const numericValue = typeof value === 'string' ? parseFloat(value) : value;

		if (isNaN(numericValue)) {
			return '0';
		}
		return Math.floor(numericValue).toLocaleString('es-ES', {
			useGrouping: true,
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		});
	};

	return {
		discounts,
		discountNames,
		discountIds,
		getDiscountByName,
		getDiscountById,
		hasDiscount,
		getDiscountOrFallback,
		formatNumberWithThousands,
	};
};
